<ui-dialog
    [open]="isOpen"
    [header]="
        'payroll.taxForms.' +
            packageTypeToBeEmailed() +
            '.emailDialog.' +
            (!!employeeName() ? 'single' : 'multiple') +
            '.title' | translate: { employee: employeeName() }
    "
    (closing)="closeDialog({ isConfirmed: false })"
    size="small"
>
    <p
        translate="payroll.taxForms.{{ packageTypeToBeEmailed() }}.emailDialog.{{
            !!employeeName() ? 'single' : 'multiple'
        }}.disclaimer"
        [translateParams]="{ employee: employeeName() }"
    ></p>
    @if (hasTaxFormsConsentFeatureFlag()) {
        <div class="consent margin-bottom-2">
            <mat-checkbox [(ngModel)]="hasProvidedConsent" />
            <div translate="payroll.taxForms.emailDialog.{{ !!employeeName() ? 'single' : 'multiple' }}.consent"></div>
        </div>
    }

    <ui-dialog-footer class="margin-top-2">
        <ui-button (click)="closeDialog({ isConfirmed: false })">{{ 'cancel' | translate }}</ui-button>
        <ui-button
            [disabled]="!!hasTaxFormsConsentFeatureFlag() && !hasProvidedConsent()"
            (click)="closeDialog({ isConfirmed: true })"
            type="primary"
            >{{ 'dashboard.send' | translate }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>
